import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from "./components/landingPage/Home";
import Supply from "./components/supplySideCampaign/Supply";
import Download from "./components/supplySideCampaign/Download";
import Blog from "./components/blog/Blog";
import CreativeServices from "./components/creativeServices/CreativeServices";
import MobileAdd from "./components/mobileAdd/MobileAdd";
import DriveStore from "./components/driveStore/DriveStore";
import SuccessStory from "./components/successStory/SuccessStory";
import About from "./components/about/About";
import Contact from "./components/contact/Contact";
import CreditCard from "./components/creditCard/CreditCard";
import Omnichannel from "./components/contact/omnichannel/Omnichannel";
import PersonalLoan from "./components/personalLoan/PersonalLoan";
import BlogHarshita from "./components/blogHarshita/BlogHarshita";
import Report from "./components/report/Report";
import ProceedToBuy from "./components/creditCard/ProceedToBuy";
import CardDetails from "./components/creditCard/CardDetails";
import Aviation from "./components/careers/Aviation";
import Gaming from "./components/careers/Gaming";
import Automobile from "./components/careers/Automobile";
import Entertainment from "./components/careers/Entertainment";
import Fmcg from "./components/careers/Fmcg";
import Bfsi from "./components/careers/Bfsi";
import Display from "./components/channelwise/Display";
import InApp from "./components/channelwise/InApp";
import Ctv from "./components/channelwise/Ctv";
import Video from "./components/channelwise/Video";
import TargetingOptions from "./components/solutions/TargetingOptions";
import Awareness from "./components/campaignwise/Awareness";
import Retargeting from "./components/campaignwise/Retargeting";
import CaseStudy from "./components/careers/CaseStudy";
import ProgrammaticAdvertising from "./components/blog/ProgrammaticAdvertising";
import TargetedAdvertising from "./components/blog/TargetedAdvertising";
import DataDrivenAdvertising from "./components/blog/DataDrivenAdvertising";
import CrossChannelAdvertising from "./components/blog/CrossChannelAdvertising";
import FutureOfDigitalAdvertising from "./components/blog/FutureOfDigitalAdvertising";
import VideoAdvertising from "./components/blog/VideoAdvertising";
import Cookie_Policy from "./components/cookiePolicy/Cookie_Policy";
import CaseStudyContainer from "./components/careers/CaseStudyContainer";
import PushAds from "./components/channelwise/PushAds";
import NativeAds from "./components/channelwise/NativeAds"
import InterstitialAds from "./components/channelwise/Interstitial-Ads"
import PrivacyPolicy from "./components/privacy/PrivacyPolicy";
import TermsAndConditions from "./components/privacy/TermsAndConditions";
import BlogMain from "./components/Blogs/BlogMain";
import BlogPost from "./components/Blogs/BlogPost";
import CtvNew from "./components/channelwise/CtvNew";
import PushAdsNew from "./components/channelwise/PushAdsNew";
import DisplayNativeAds from "./components/channelwise/DisplayNativeAds";
import InappMobileAds from "./components/channelwise/InappMobilAds";
import BrandAwareness from "./components/campaignwise/BrandAwareness";
import DemographicsTargeting from "./components/solutions/DemographicsTargeting";
import InterestBehaviorTargeting from "./components/solutions/InterestBehaviorTargeting";
import HouseholdSyncTargeting from "./components/solutions/HouseholdSyncTargeting";
import VideoStorytellingAds from "./components/campaignwise/VideoStorytellingAds";
import PremiumTakeovers from "./components/campaignwise/PremiumTakeovers";
import ReengagementRetargeting from "./components/campaignwise/ReengagementRetargeting";
import GeoHyperlocalTargeting from "./components/solutions/GeoHyperlocalTargeting";
import LookalikeCustomAudience from "./components/solutions/LookalikeCustomAudience";
import Education from "./components/careers/Education";
import Others from "./components/careers/Others";
import GalleryPage from "./components/AdGallery.js/GalleryPage";
import OreoDetail from "./components/AdGallery.js/OreoDetail";
import TuskerDetail from "./components/AdGallery.js/TuskerDetail";
import MilesDetail from "./components/AdGallery.js/MilesDetail";
import BlackLableDetail from "./components/AdGallery.js/BlackLableDetail";
import CocDetail from "./components/AdGallery.js/CocDetail";
import OralDetail from "./components/AdGallery.js/OralDetail";
import PepsiDetail from "./components/AdGallery.js/PepsiDetail";
import SamsungDetail from "./components/AdGallery.js/SamsungDetail";
import MollersDetail from "./components/AdGallery.js/MollersDetail";
import TigerDetail from "./components/AdGallery.js/TigerDetail";
import MintDetail from "./components/AdGallery.js/MintDetail";
import BirraDetail from "./components/AdGallery.js/BirraDetail";
import AbcBeerDetail from "./components/AdGallery.js/AbcBeerDetail";
import MarsDetail from "./components/AdGallery.js/MarsDetail";
import VivoDetail from "./components/AdGallery.js/VivoDetail";
import ElmenhorsterDetail from "./components/AdGallery.js/ElmenhorsterDetail";
import ZenDetail from "./components/AdGallery.js/ZenDetail";
import LiptonDetail from "./components/AdGallery.js/LiptonDetail";
import LaysDetail from "./components/AdGallery.js/LaysDetail";
import SamsungFoldDetail from "./components/AdGallery.js/SamsungFoldDetail";
import SamsungFoldNew from "./components/AdGallery.js/SamsungFoldNew";
import FantaDetail from "./components/AdGallery.js/FantsDetails";
import Ps5 from "./components/AdGallery.js/Ps5";
import AdPage1 from "./components/AdGallery.js/Ad1";
import AdPage2 from "./components/AdGallery.js/Ad2";
import AdPage3 from "./components/AdGallery.js/Ad3";
import AdPage4 from "./components/AdGallery.js/Ad4";
import AdPage5 from "./components/AdGallery.js/Ad5";
import MamaEarthDetail from "./components/AdGallery.js/MamaEarthDetail";
import Ad11 from "./components/AdGallery.js/Ad11";
import Canesten from "./components/AdGallery.js/Canesten";
import Car360 from "./components/AdGallery.js/Car360";
import LuxaryCloseset from "./components/AdGallery.js/LuxaryCloseset";
import RamdhanQuizzDetail from "./components/AdGallery.js/RamdhanQuizzDetail";
import TravelRamdhan from "./components/AdGallery.js/TravelRamdhan";
import ResponsiveDonationFlow from "./components/AdGallery.js/ResponsiveDonationFlow";
import ResponsiveZakatCalculatorFlow from "./components/AdGallery.js/ResponsiveZakatCalculatorFlow";
import LenovoAd from "./components/AdGallery.js/LenovoAd";
import DlfVideo from "./components/AdGallery.js/DlfVideo";
import RecardDetail from "./components/AdGallery.js/RecardDetail";
import PlbDetail from "./components/AdGallery.js/PlbDetail";
import RealtyDetail from "./components/AdGallery.js/RealtyDetail";
import TelegramPush from "./components/AdGallery.js/TelegramPush";
import StaccatoDetail from "./components/AdGallery.js/StaccatoDetail";
const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    // errorElement: <ErrorPage />,
    children: [
      {
        path: "/push-notification/staccato",
        element: <StaccatoDetail />
      },
      {
        path: "/push-notification/fitflop",
        element: <TelegramPush />
      },
      {
        path: "/ctv-l-band/realty",
        element: <RealtyDetail />
      },
      {
        path: "/ctv-j-band/plb",
        element: <PlbDetail />
      },
      {
        path: "/ctv-quiz/recard",
        element: <RecardDetail />
      },
      {
        path: "/ctv-qr-code-l-band/dlf",
        element: <DlfVideo/>
      },
      {
        path: "/ctv-carousel-l-band/lenovo",
        element: <LenovoAd/>
      },
      {
        path: "/dynamic-calculator/zakat",
        element: <ResponsiveZakatCalculatorFlow/>
      },
      {
        path: "/interactive-selector/donation",
        element: <ResponsiveDonationFlow/>
      },
      {
        path: "/interactive-selector/travel-ramadan",
        element: <TravelRamdhan/>
      },
      {
        path: "/quiz/ramadan",
        element: <RamdhanQuizzDetail/>
      },
      {
        path: "/hotspot/luxarycloset",
        element: <LuxaryCloseset/>
      },
      {
        path: "/360rotate/carrotate",
        element: <Car360/>
      },
      {
        path: "/gamification/canesten",
        element: <Canesten/>
      },
      {
        path: "/3d-prism/prism",
        element: <Ad11/>
      },
      {
        path: "/spin-the-wheel/mamaearth",
        element: <MamaEarthDetail/>
      },
      {
        path: "/blinds/travel",
        element: <AdPage5/>
      },
      {
        path: "/ad4",
        element: <AdPage4/>
      },
      {
        path: "/tap-to-reveal/thumsup",
        element: <AdPage3/>
      },
      {
        path: "/swipe-to-reveal/pizza",
        element: <AdPage2/>
      },
      {
        path: "/scratch-to-win/hm",
        element: <AdPage1/>
      },
      {
        path: "/tap-to-reveal/ps",
        element: <Ps5/>
      },
      {
        path: "/fanta",
        element: <FantaDetail/>
      },
      {
        path: "/foldnew",
        element: <SamsungFoldNew/>
      },
      {
        path: "/fold",
        element: <SamsungFoldDetail/>
      },
      {
        path: "/lays",
        element: <LaysDetail/>
      },
      {
        path: "/lipton",
        element: <LiptonDetail/>
      },
      {
        path: "/zen",
        element: <ZenDetail/>
      },
      {
        path: "/elmenhorster",
        element: <ElmenhorsterDetail/>
      },
      {
        path: "/vivo",
        element: <VivoDetail/>
      },
      {
        path: "/mars",
        element: <MarsDetail/>
      },
      {
        path: "/drag-to-reveal/abcbeer",
        element: <AbcBeerDetail/>
      },
      {
        path: "/birra",
        element: <BirraDetail/>
      },
      {
        path: "/mint",
        element: <MintDetail/>
      },
      {
        path: "/video/tiger",
        element: <TigerDetail/>
      },
      {
        path: "/video/mollers",
        element: <MollersDetail/>
      },
      {
        path: "/gamification/samsung",
        element: <SamsungDetail/>
      },
      {
        path: "/native-display/pepsi",
        element: <PepsiDetail/>
      },
      {
        path: "/oral",
        element: <OralDetail/>
      },
      {
        path: "/coke",
        element: <CocDetail/>
      },
      {
        path: "/coke",
        element: <CocDetail/>
      },
      {
        path: "/lable",
        element: <BlackLableDetail/>
      },
      {
        path: "/miles",
        element: <MilesDetail/>
      },
      {
        path: "/tusker",
        element: <TuskerDetail/>
      },
      {
        path: "/oreo",
        element: <OreoDetail/>
      },
      {
        path: "/ad-gallery",
        element: <GalleryPage/>
      },
      {
        path: "/lookalike-custom-audiences",
        element: <LookalikeCustomAudience/>
      },
      {
        path: "/householdsync-targeting",
        element: <HouseholdSyncTargeting/>
      },
      {
        path: "/interest-behavior-targeting",
        element: <InterestBehaviorTargeting/>
      },
      {
        path: "/demographics-targeting",
        element: <DemographicsTargeting/>
      },
      {
        path: "/geo-hyperlocal-targeting",
        element: <GeoHyperlocalTargeting/>
      },
      {
        path: "/reengagement-retargeting",
        element: <ReengagementRetargeting/>
      },
      {
        path: "/premium-takeovers",
        element: <PremiumTakeovers/>
      },
      {
        path: "/video-storytelling-ads",
        element: <VideoStorytellingAds/>
      },

      {
        path: "/brand-awareness",
        element: <BrandAwareness/>
      },
      {
        path: "/inapp-mobile-Ads",
        element: <InappMobileAds/>
      },
      {
        path: "/display-native-ads",
        element: <DisplayNativeAds/>
      },
      {
        path: "/push-ads",
        element: <PushAdsNew/>
      },
      {
        path: "/ctv&ott",
        element: <CtvNew/>
      },
      {
        path: "/blog",
        element: <BlogMain/>
      },
      {
        path: "/blog/:id",
        element: <BlogPost/>
      },
      {
        path: "/terms-and-conditions",
        element: <TermsAndConditions />
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />
      },
      {
        path: "/push-ads",
        element: <PushAds/>
      },
      {
        path: "/native-ads",
        element: <NativeAds />

      },
      {
        path: "/interstitial-ads",
        element: <InterstitialAds />
      },
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/supply",
        element: <Supply />,
      },
      {
        path: "/download",
        element: <Download />,
      },
      {
        path: "/blogs",
        element: <Blog />,
      },
      {
        path: "/Programmatic-advertising",
        element: <ProgrammaticAdvertising />,
      },
      {
        path: "/Targeted-advertising",
        element: <TargetedAdvertising />,
      },
      {
        path: "/Data-driven-advertising",
        element: <DataDrivenAdvertising />,
      },
      {
        path: "/cross-channel-advertising",
        element: <CrossChannelAdvertising />,
      },
      {
        path: "/future-of-digital-advertising",
        element: <FutureOfDigitalAdvertising />,
      },
      {
        path: "/video-advertising",
        element: <VideoAdvertising />,
      },
      {
        path: "/creativeServices",
        element: <CreativeServices />,
      },
      {
        path: "/mobileAdd",
        element: <MobileAdd />,
      },
      {
        path: "/omnichannel",
        element: <Omnichannel />,
      },
      {
        path: "/driveStore",
        element: <DriveStore />,
      },
      // {
      //   path: "/success",
      //   element: <SuccessStory />,
      // },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/credit-card",
        element: <CreditCard />,
      },
      {
        path: "/personal-loan",
        element: <PersonalLoan />,
      },
      {
        path: "/blog_harshita",
        element: <BlogHarshita />,
      },
      {
        path: "/report",
        element: <Report />,
      },
      {
        path: "/proceed-to-buy",
        element: <ProceedToBuy />,
      },
      {
        path: "/card-details",
        element: <CardDetails />,
      },
      {
        path: "/awareness",
        element: <Awareness />,
      },
      {
        path: "/re-targeting",
        element: <Retargeting />,
      },
      {
        path: "/display",
        element: <Display />,
      },
      {
        path: "/in-app",
        element: <InApp />,
      },
      {
        path: "/ctv",
        element: <Ctv />,
      },
      {
        path: "/video",
        element: <Video />,
      },
      {
        path: "/targeting-options",
        element: <TargetingOptions />,
      },
      {
        path: "/case-study",
        element: <CaseStudyContainer />,
      },
      {
        path: "/other-case-study",
        element: <Others/>
      },
      {
        path: "/bfsi",
        element: <Bfsi />,
      },
      {
        path: "/fmcg",
        element: <Fmcg />,
      },
      {
        path: "/entertainment",
        element: <Entertainment />,
      },
      {
        path: "/automobile",
        element: <Automobile />,
      },
      {
        path: "/education",
        element: <Education/>
      },
      {
        path: "/fashion-lifestyle",
        element: <Gaming />,
      },
      {
        path: "/electronics",
        element: <Aviation />,
      },
      {
        path: "/cookie-policy",
        element: <Cookie_Policy />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={appRouter} />);
